<script setup lang="ts">
const { t } = useLocale()
const { trackClickInOrderListTabs } = useGTM()

const buttonInProgress = ref(true)
const buttonCompleted = ref(false)

const selectInProgress = () => {
  trackClickInOrderListTabs(true)
  buttonInProgress.value = true
  buttonCompleted.value = false
}

const selectCompleted = () => {
  trackClickInOrderListTabs(false)
  buttonInProgress.value = false
  buttonCompleted.value = true
}
</script>
<template>
  <header class="mb-8 flex gap-2 px-4 shadow-xl md:p-0 md:shadow-none">
    <button
      class="flex h-8 w-full justify-center md:w-32"
      :class="{ 'border-b-4 border-b-mcd-main': buttonInProgress }"
      @click="selectInProgress()"
    >
      <h3 :class="buttonInProgress ? 'font-bold' : ' font-normal'" class="text-sm font-bold">
        {{ t('orders.buttons.onGoing').toUpperCase() }}
      </h3>
    </button>

    <button
      data-test="finished-orders"
      class="flex h-8 w-full justify-center md:w-32"
      :class="{ 'border-b-4 border-b-mcd-main': buttonCompleted }"
      @click="selectCompleted()"
    >
      <h3 :class="buttonCompleted ? 'font-bold' : ' font-normal'" class="text-sm font-bold">
        {{ t('orders.buttons.finished').toUpperCase() }}
      </h3>
    </button>
  </header>

  <InProgressOrder v-if="buttonInProgress" />
  <LazyCompletedOrder v-else />
</template>
